var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Close_icon",
    "data-name": "Close icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Close_icon-2",
    "data-name": "Close icon",
    d: "M9,11.842,2.842,18,0,15.158,6.158,9,0,2.842,2.842,0,9,6.158,15.158,0,18,2.842,11.842,9,18,15.158,15.158,18Z",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseicon);
export default __webpack_public_path__ + "static/media/Close icon.0c85a4a0fc2a71fb80e618d1f2cc193d.svg";
export { ForwardRef as ReactComponent };